import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import t from "../../../core/Accessor.js";
import { property as r } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../../core/accessorSupport/decorators/subclass.js";

var o = /*#__PURE__*/function (_t) {
  _inherits(o, _t);

  var _super = _createSuper(o);

  function o(e) {
    var _this;

    _classCallCheck(this, o);

    _this = _super.call(this), _this.nativeIndex = null, _this._detectedDeviceType = "unknown", "standard" === e.mapping ? _this._detectedDeviceType = "standard" : n.test(e.id) ? _this._detectedDeviceType = "spacemouse" : _this._detectedDeviceType = "unknown", _this.nativeIndex = e.index;
    return _this;
  }

  _createClass(o, [{
    key: "native",
    get: function get() {
      return (navigator.getGamepads ? navigator.getGamepads() : [])[this.nativeIndex];
    }
  }, {
    key: "deviceType",
    get: function get() {
      return this._detectedDeviceType;
    }
  }, {
    key: "axisThreshold",
    get: function get() {
      return a[this.deviceType];
    }
  }]);

  return o;
}(t);

e([r({
  nonNullable: !0,
  readOnly: !0
})], o.prototype, "nativeIndex", void 0), e([r({
  type: String,
  readOnly: !0
})], o.prototype, "deviceType", null), e([r({
  type: Number,
  readOnly: !0
})], o.prototype, "axisThreshold", null), o = e([s("esri.views.input.gamepad.GamepadInputDevice")], o);
var n = new RegExp("^(3dconnexion|space(mouse|navigator|pilot|explorer))", "i"),
    a = {
  standard: .15,
  spacemouse: .025,
  unknown: 0
},
    i = o;
export { i as default };